import featureImg from './feature.png';
export { featureImg };
